var React = require('react');

function Qatesting (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"48","height":"48","rx":"14","fill":"#5A4670","key":0}),React.createElement("path",{"d":"M23.5 33C28.7467 33 33 28.7467 33 23.5C33 18.2533 28.7467 14 23.5 14C18.2533 14 14 18.2533 14 23.5C14 28.7467 18.2533 33 23.5 33Z","stroke":"#A472D7","strokeWidth":"1.8","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M34 34L32 32","stroke":"#A472D7","strokeWidth":"1.8","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M20.4524 23.7669L22.3733 25.6683L26.5061 21.8848","stroke":"#A472D7","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":3})]);
}

Qatesting.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = Qatesting;

Qatesting.default = Qatesting;
